module.exports = __webpack_public_path__ + "img/FR21570.993b1da2.png";